const timezone = process.env.REACT_APP_TIMEZONE ?? 'UTC'
const locale = process.env.REACT_APP_LOCALE ?? 'nl-BE'
// Timestamp of '20/12/2025, 14:23:16 (C/A)EST'
export const localizedDateTimeFormatter = new Intl.DateTimeFormat(locale, {
  timeZone: timezone,
  dateStyle: 'short',
  timeStyle: 'long'
})
